import React from "react";
import { useWorkflowApi } from "./useWorkflowApi";
import { ITransition, IGetGoToRequest } from "./Models";

import UnauthorizedModal from "./UnauthorizedModal";
import HtmlWorkflowDialog from "./HtmlWorkflowDialog";
import LoadingModal from "../../common/components/LoadingModal";
import ErrorModal from "../../common/components/ErrorModal";

function getGoToRequest(transition: ITransition): IGetGoToRequest {
	let qdesk = (window as any).qdesk;
	if (qdesk.issues && qdesk.issues.issueType == "Task") {
		return {
			url: "/Workflow/TaskGotoAjax",
			params: {
				transitionId: transition.id,
				taskId: transition.issueId,
			}
		}
	}
	else
		return {
			url: "/Workflow/GotoAjax",
			params: {
				transitionId: transition.id,
				issueId: transition.issueId,
				serviceId: transition.serviceId,
			}
		};
}

export interface IModalWorkflowApi {
	runUrl: (url: string) => void,
	runTransition: (transition: ITransition) => void
}

interface IUrlObject {
	url: string,
}

export default function ModalWorkflow()
{
	const [transitionUrl, setTransitionUrl] = React.useState<IUrlObject>(null);
	const runUrlCallback = React.useCallback((url: string) => setTransitionUrl({ url: url }), []);

	const [transition, setTransition] = React.useState(null);
	const runTransitionCallback = React.useCallback((tr) => setTransition(tr), []);

	const [html, json, isLoading, errorCode, goToRequest, setGoToRequest, cancel] = useWorkflowApi();

	React.useEffect(() => {
		checkUrl();
	}, [])

	React.useEffect(() => {
		if (transitionUrl) {
			_prepareOpenNewModal();
			setGoToRequest({
				url: transitionUrl.url
			});
		}
	}, [transitionUrl])

	React.useEffect(() => {
		if (transition)
			_runTransition(transition);
	}, [transition])
	
	function checkUrl() {
		let query = window.location.search.substring(1);
		var paramsQuery = _parseQueryString(query);
		if (paramsQuery.m_transition) {
			let t: ITransition = {
				id: paramsQuery.m_transition,
				issueId: paramsQuery.m_issueId,
				serviceId: paramsQuery.m_serviceId
			};

			_runTransition(t);
		}
	}

	function _parseQueryString(query): any {
		var vars = query.split("&");
		var query_string = {};
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			var key = decodeURIComponent(pair[0]);
			var value = decodeURIComponent(pair[1]);
			// If first entry with this name
			if (typeof query_string[key] === "undefined") {
				query_string[key] = decodeURIComponent(value);
				// If second entry with this name
			} else if (typeof query_string[key] === "string") {
				var arr = [query_string[key], decodeURIComponent(value)];
				query_string[key] = arr;
				// If third or later entry with this name
			} else {
				query_string[key].push(decodeURIComponent(value));
			}
		}
		return query_string;
	}

	function handleClose() {
		setGoToRequest(null);
	}

	function _prepareOpenNewModal(): boolean {
		let qdesk = (window as any).qdesk;
		if (qdesk.header && qdesk.header.closeAddIssuesCatalog)
			qdesk.header.closeAddIssuesCatalog();

		return true;
	}

	function _runTransition(transition: ITransition): void {
		_prepareOpenNewModal();
		let goToReq = getGoToRequest(transition);
		setGoToRequest(goToReq);
	}

	var modalWorkflow: IModalWorkflowApi = {
		runUrl: runUrlCallback,
		runTransition: runTransitionCallback,
	};

	(window as any).qdesk.workflow.modalWorkflow = modalWorkflow;

	if (errorCode == 500) {
		return <ErrorModal onClose={() => cancel()} />
	}
	if (errorCode == 401) {
		return <UnauthorizedModal onClose={() => cancel()} />
	}
	if (isLoading) {
		return <LoadingModal onCancel={() => cancel()} />
	}

	if (html) {
		return <HtmlWorkflowDialog html={html} onClose={handleClose} />;
	}

	return null;
}
